import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-bootstrap';
import { translate } from 'react-i18next';
import AppIcon from '../../components/AppIcon';
import InnerHtmlContent from '../InnerHtmlContent';

const SelectionPathInfo = ({ namespace, prefix, path, t }) => {
  if (path.length > 0) {
    // We probably do not need the divider, the &#124 is the pipe character '|'
    const divider = (
      <div className="path-details">
        <span className="path-details-option-title">&#124;</span>
      </div>);
    const list = path.map(element => (
      <Col className="path-details" key={element.id} xs={12} sm={6} md={6} lg={6}>
        <span className="path-details-option-title">{t(`${prefix}.${element.id}.title`)} </span>
        <span className="path-details-option-desc">{t(`${prefix}.${element.id}.subTitle`, { defaultValue: '' })}</span>
      </Col>
      )
    );
    // const view = list.reduce((prev, curr) => [prev, divider, curr]);
    const lastLevel = path[path.length - 1];
    return (
      <div className="selection-path-info-box">
        <Grid fluid className="path-selection-wrapper">
          <Row>
            {list}
          </Row>
        </Grid>
        {t(`${prefix}.${lastLevel.id}.instructions`) !== `${prefix}.${lastLevel.id}.instructions` ? (
          <div className="selection-path-info-text">
            <AppIcon iconName="INFO" containerClass="info-icon" />
            <p>
              <InnerHtmlContent content={t(`${prefix}.instructions`)} />
              <InnerHtmlContent content={t(`${prefix}.${lastLevel.id}.instructions`, { defaultValue: '' })} />
            </p>
            <div className="clearfix" />
          </div>
          ) :
          null}
      </div>
    );
  }
  return <div />;
};

SelectionPathInfo.propTypes = {
  namespace: PropTypes.string.isRequired,
  prefix: PropTypes.string.isRequired,
  path: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired
};

export default translate(props => props.namespace)(SelectionPathInfo);



// WEBPACK FOOTER //
// ./src/components/SelectionPathInfo/index.jsx